import { Adapter as r } from "../../adapter.js";
import { AudienceModel as o } from "./audience.model.js";
class n extends r {
  adapt(e) {
    return new o({
      operation: e.operation,
      type: e.type,
      unit: e.unit,
      value: e.value
    });
  }
  serialize(e) {
  }
}
export {
  n as AudienceAdapter
};
//# sourceMappingURL=audience.adapter.js.map
